<div>
  <div class="row unidades" style="opacity: 0.8;">
    <div class="col-md-1 col-xs-1 selector-unidades" [ngClass]="{'selected': currentUnidadMedida === unidadMedida.CM}">
      <span (click)="changeUnidadMedida(unidadMedida.CM)">Cm</span>
    </div>
    <div class="col-md-1 col-xs-1 col-no-padding">
      <!-- <div class="circulo"></div> -->
    </div> 
    <div class="col-md-10 col-xs-8 selector-unidades" [ngClass]="{'selected': currentUnidadMedida === unidadMedida.INCHES}">
      <span (click)="changeUnidadMedida(unidadMedida.INCHES)">{{language.PULGADAS}}</span>
    </div>
  </div>

  <div class="row languages-container">
    <ul class="languages">
      <li [ngClass]="{'active': currentLanguage === languageId.SPANISH}" (click)="selectLanguage(languageId.SPANISH)">ES</li>
      <li [ngClass]="{'active': currentLanguage === languageId.ENGLISH}" (click)="selectLanguage(languageId.ENGLISH)">EN</li>
      <li [ngClass]="{'active': currentLanguage === languageId.FRENCH}" (click)="selectLanguage(languageId.FRENCH)">FR</li>
    </ul>
  </div>

  <br>
  <!-- <div class="menu-icon">
    <img src="assets/img-svg/menu.png" alt="">
  </div> -->
  <tree-menu
  (test)="addfilter($event)"
  [data]="orderParentNode(treeSchema)"
  ></tree-menu>

  <br>
  <br>
</div>